import { PageHeading, UserRoleHeading } from "@/components/Layout/Parts";
import AddInvoiceForm from "./components/AddInvoiceForm";

const AddInvoice = () => {
  return (
    <>
      <UserRoleHeading />
      <PageHeading>Add Invoice</PageHeading>
      <AddInvoiceForm />
    </>
  );
};

export default AddInvoice;
